import type { RootState } from "store";

export const selectUnitSystem = (state: RootState) => state.app.unitSystem;
